import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'

const app = createApp(App);
app.use(store).use(router).use(VueCookies).mount('#app')

